/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { MdLockOutline, MdPersonOutline } from 'react-icons/md';
import { Button, Form, Input, InputGroupAddon, Spinner } from 'reactstrap';
import logo from '~/assets/Logo_oficial.png';
import { Container } from './styles';

function LoginCard({
  form,
  setForm,
  handleLogin,
  loading,
  setTogglePassword,
  togglePassword,
}) {
  return (
    <Container>
      <img src={logo} alt="Orgsystem" />
      <Form onSubmit={handleLogin} style={{ width: '100%' }}>
        <p>Informe seu usuário e senha para acessar</p>
        <div className="inputArea">
          <MdPersonOutline size={20} />
          <Input
            disabled={loading}
            required
            placeholder="Seu usuário"
            name="user"
            type="text"
            onChange={(e) => setForm({ ...form, user: e.target.value })}
          />
        </div>
        <div className="inputArea">
          <MdLockOutline size={20} style={{ marginRight: '5px' }} />
          <Input
            disabled={loading}
            required
            type={!togglePassword ? 'password' : 'text'}
            name="password"
            placeholder="Sua senha"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <InputGroupAddon addonType="append">
            <Button
              color="primary"
              onClick={() => {
                setTogglePassword(!togglePassword);
              }}
            >
              {!togglePassword ? <FaEye /> : <FaEyeSlash />}
            </Button>
          </InputGroupAddon>
        </div>

        {loading ? (
          <Button className="btn" type="submit" color="primary" disabled>
            <Spinner size="sm" color="#FFF" />
          </Button>
        ) : (
          <Button className="btn login-btn" color="primary">
            Entrar
          </Button>
        )}
      </Form>
    </Container>
  );
}

LoginCard.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  setTogglePassword: PropTypes.func.isRequired,
  togglePassword: PropTypes.bool.isRequired,
};

export default LoginCard;
